<template>
  <div class="container">
    <h1 class="text-h6">
      {{ $t('errors.notFound.title') }}
    </h1>
    <h2 class="subtitle" id="route-name">
      {{ $t('errors.notFound.description', { routeName }) }}
    </h2>
  </div>
</template>

<script>
export default {
  props: {
    routeName: {
      type: String,
      required: true,
    },
  },
  name: 'PageNotFound',
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped></style>
